import { useLocale } from "hooks";
import Image from "components/Image";
import translation from "./translation";
import clsx from "clsx";
import Link from "next/link";
import styled from "styled-components";

const ConferenceCard = ({ item, className }) => {
  const { locale } = useLocale();
  return (
    <Link href={item?.link} passHref prefetch={false} hrefLang={locale}>
      <a
        key={item?.id}
        className={clsx("tw-flex tw-flex-col tw-group", className)}
      >
        <div className="tw-aspect-[1.5] tw-relative tw-rounded-lg tw-overflow-hidden">
          <Image
            width={150}
            height={100}
            src={item?.image}
            alt={item?.alt}
            className="tw-transition-all tw-rounded-lg xxxl:tw-rounded-[10.64px] tw-w-full tw-h-full tw-object-cover"
          />
        </div>
        <span className="tw-text-[#344456] tw-text-base xxxl:tw-text-[21.27px] tw-font-bold tw-mt-4 xxxl:tw-mt-[26.7px] group-hover:tw-text-[#007FAC] tw-transition-all tw-min-h-[50px] xxxl:tw-leading-[36.07px] title">
          {item?.title}
        </span>
        <p className="tw-text-[#344456]/40 tw-text-[13px] xxxl:tw-text-[17.29px] tw-mt-1 xxxl:tw-mt-[5.32px]">
          <span>{translation[locale]?.PUBLISH_DATE}: </span>
          <span>{item?.date}</span>
        </p>
      </a>
    </Link>
  );
};

const StyledConferenceCard = styled(ConferenceCard)`
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  img {
    transition: transform 0.3s;
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export default StyledConferenceCard;
